import React, { useEffect, useState, useRef } from "react";
import { gsap } from "gsap";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useDynamic } from "../../hooks/DynamicProvider";
// Assuming these imports are correct in your project structure
import rexla_icon from "../../assets/images/hub/rexla-bg.png";
import rexla_letter from "../../assets/images/hub/rexla.png";
import rexla_logo from "../../assets/images/hub/logo.png";

import user_icon from "../../assets/images/hub/user.png";
import "./hub.css";
import DisclaimerPopup from "../../components/DisclaimerPopup";

const items = [
  {
    name: "RXG",
    image: "./assets/images/access/RXG.png",
    label: "./assets/images/labels/TOKEN.png",
    link: "https://rexla.com/ico",
  },
  {
    name: "Protect",
    image: "./assets/images/access/PROTECT.png",
    label: "./assets/images/labels/Protect.png",
    description:
      "Coming soon - protect your assets in the event of your incapacitation or death along with other protection services.",
  },
  {
    name: "Wallet",
    label: "./assets/images/labels/WALLET.png",
    image: "./assets/images/access/WALLET3.png",
  },
  {
    name: "H2X",
    image: "./assets/images/access/H2X.png",
    label: "./assets/images/labels/H2X.png",
    description: "Coming Soon - origin tracked water brand with a difference.",
  },
  /* {
    name: "USocial",
    image: "./assets/images/access/USOCIAL.png",
    label: "./assets/images/labels/social.png",
    description:
      "Coming Soon - Reimagining Social Media Interaction with Human-centric Ethical Algorithms and Blockchain Foundations.",
  }, */
  {
    name: "XYRA",
    image: "./assets/images/access/XYRO.png",
    label: "./assets/images/labels/XYRA.png",
    link: "https://xyra.one/",
  },
  {
    name: "RWF",
    image: "./assets/images/access/RWF.png",
    label: "./assets/images/labels/RWF.png",
    link: "http://rexlaglobal.com/rwf/",
  },
  {
    name: "Academy",
    image: "./assets/images/access/ACADEMY2.png",
    label: "./assets/images/labels/academy.png",
    description:
      "Coming Soon - Rexla Academy, learn in your own way at your own pace.",
  },
  {
    name: "EMPORIA",
    image: "./assets/images/access/EMPORIA.png",
    label: "./assets/images/labels/EMPORIA.png",
    description:
      "Welcome to Emporia! Discover a world of treasures at Emporia, the virtual mall. Experience online shopping reimagined with seamless navigation, exclusive brands, and hidden gems - all in one innovative marketplace. Dive into the future of retail with immersive features that will include Virtual Reality (VR), transforming shopping into a dynamic and interactive journey. Start exploring soon!",
  },
  {
    name: "HIO",
    image: "./assets/images/access/HIO20022.png",
    label: "./assets/images/labels/HIO.png",
    link: "https://www.hiomusic.com",
  },
  {
    name: "Rexla",
    image: "./assets/images/access/Rex.png",
    label: "./assets/images/labels/REX.png",
    description:
      "Hi I'm Rex, your helpful Ai guide, soon I'll be able to assist you in every step here.",
  },

  /* { name: "Exchange", image: "./assets/images/access/REXCHANGE.png" }, */
];

const Hub = () => {
  const navigate = useNavigate();
  const { isLoggedIn, isLoading, handleConnectWallet, userInfo } = useDynamic();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showTooltip, setShowTooltip] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const touchStartTime = useRef(0);
  const touchEndTime = useRef(0);
  const isSwiping = useRef(false);

  // Constants for touch interaction
  const SWIPE_THRESHOLD = 75; // minimum distance for swipe
  const SWIPE_TIMEOUT = 300; // maximum time for swipe in milliseconds

  const rotateLeft = () => {
    setShowTooltip(false);
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? items.length - 1 : prevIndex - 1
    );
  };

  const rotateRight = () => {
    setShowTooltip(false);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartTime.current = Date.now();
    isSwiping.current = false;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
    const deltaX = Math.abs(touchEndX.current - touchStartX.current);

    // If the user has moved their finger more than 10px, consider it a swipe
    if (deltaX > 10) {
      isSwiping.current = true;
    }
  };

  const handleTouchEnd = () => {
    touchEndTime.current = Date.now();
    const touchDuration = touchEndTime.current - touchStartTime.current;
    const touchDistance = Math.abs(touchEndX.current - touchStartX.current);

    // Only process as a swipe if:
    // 1. The duration is under the threshold
    // 2. The distance is over the threshold
    // 3. We detected movement during the touch
    if (
      touchDuration < SWIPE_TIMEOUT &&
      touchDistance > SWIPE_THRESHOLD &&
      isSwiping.current
    ) {
      if (touchStartX.current - touchEndX.current > SWIPE_THRESHOLD) {
        rotateRight();
      } else if (touchEndX.current - touchStartX.current > SWIPE_THRESHOLD) {
        rotateLeft();
      }
    }

    // Reset values
    touchStartX.current = 0;
    touchEndX.current = 0;
    touchStartTime.current = 0;
    touchEndTime.current = 0;
    isSwiping.current = false;
  };

  const handleGetStartedClick = (e) => {
    e.preventDefault();
    // Show tooltip
    setShowTooltip(!showTooltip);

    // Handle the original click action after a brief delay

    const currentItem = items[currentIndex];
    if (items[currentIndex].name === "Wallet") {
      handleConnectWallet();
    } else if (currentItem.link) {
      window.open(currentItem.link, "_blank");
    }
  };

  const getItemStyle = (index) => {
    const positions = [
      { left: "50%", bottom: "20%" },
      { left: "80%", bottom: "10%" },
      { left: "65%", bottom: "30%" },
      { left: "50%", bottom: "20%" },
      { left: "50%", bottom: "20%" },
      { left: "50%", bottom: "20%" },
      /* { left: "50%", bottom: "20%" }, */
      { left: "50%", bottom: "20%" },
      { left: "50%", bottom: "20%" },
      { left: "35%", bottom: "30%" },
      { left: "20%", bottom: "10%" },
    ];

    const opacities = [1, 0.8, 0.3, 0, 0, 0, 0, 0, 0.3, 0.8];

    const rotatedIndex = (index - currentIndex + items.length) % items.length;
    const position = positions[rotatedIndex];

    return {
      position: "absolute",
      transition: "all 0.5s ease-in-out",
      transform:
        rotatedIndex === 0
          ? "translateX(-50%) scale(2.1)"
          : "translateX(-50%) scale(1)",
      zIndex: rotatedIndex === 0 ? 10 : 1,
      opacity: opacities[rotatedIndex],
      ...position,
    };
  };

  useEffect(() => {
    const tl = gsap.timeline();
    tl.fromTo(
      ".hub .icon-area",
      { left: "73%", top: "-85px", translateY: "0" },
      {
        left: "50%",
        top: "-20px",
        translateY: "-32vh",
        duration: 1,
        delay: 0.5,
      },
      "+=0.5"
    )
      .fromTo(
        ".hub .shadow-block",
        { boxShadow: "none" },
        {
          boxShadow:
            "#82bef982 0px 0px 60px 13px, #67acef80 0px 0px 30px inset",
          duration: 2,
        }
      )
      .fromTo(
        ".hub .rexla-icon",
        {
          filter: "none",
        },
        {
          filter: "none",
          duration: 2,
        },
        "-=2"
      )
      .fromTo(
        ".hub .spotlight",
        { opacity: 0 },
        {
          visibility: "visible",
          opacity: 1,
          duration: 2,
        },
        "-=2"
      )
      .fromTo(
        ".hub .hub-btn",
        { opacity: 0 },
        {
          opacity: 1,
          duration: 2,
        },
        "-=2"
      )
      .fromTo(
        ".hub .slider-box",
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
        }
      )
      .fromTo(
        ".hub .slider-btns",
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
        },
        "-=1"
      )
      .fromTo(
        ".hub .left-btn",
        { x: 15 },
        {
          x: 0,
          duration: 1,
        },
        "-=1"
      )
      .fromTo(
        ".hub .right-btn",
        { x: -15 },
        {
          x: 0,
          duration: 1,
        },
        "-=1"
      )
      .fromTo(
        ".hub .rexla-logo",
        { y: 0, opacity: 1 },
        {
          y: "60vh",
          opacity: 0,
          duration: 2.5,
          delay: 0.5,
        },
        "-=4.5"
      )
      .fromTo(
        ".hub .profile-btn",
        { opacity: 0 },
        {
          opacity: 1,
          zIndex: 1,
          duration: 2,
        },
        "-=2"
      )
      .fromTo(".hub .profile-btn:disabled", { opacity: 0 }, { opacity: 0.6 })
      .fromTo(
        ".hub .disclaimer-modal",
        { opacity: 0, y: -200 },
        { opacity: 1, y: 0 }
      )
      .fromTo(".modal-backdrop", { opacity: 0 }, { opacity: 0.3 }, "-=1")
      .fromTo(
        ".hub .hub-footer",
        { y: "50px", opacity: 0 },
        { y: "0px", opacity: 1 }
      );

    return () => {
      tl.kill();
    };
  }, []);

  return (
    <div className="hub main">
      <DisclaimerPopup />
      <div className="hub-slider">
        {isLoggedIn ? (
          <button
            className="btn profile-btn"
            onClick={() => navigate("/user")}
            disabled={isLoading}
          >
            <img src={user_icon} alt="user icon" />
          </button>
        ) : (
          <button
            className="btn profile-btn"
            onClick={() => handleConnectWallet()}
            disabled={isLoading}
          >
            <img src={user_icon} alt="user icon" />
            {!isLoading && <span>LOGIN</span>}
          </button>
        )}
        <div className="logo-area">
          <div className="position-relative">
            <img src={rexla_logo} alt="logo" className="rexla-logo" />
            <div className="icon-area">
              <div className="shadow-block" />
              <img src={rexla_icon} alt="rexla icon" className="rexla-icon" />
              <img
                src={rexla_letter}
                alt="rexla icon"
                className="rexla-symbol"
              />
            </div>
          </div>
        </div>

        <div className="spotlight"></div>
        <div
          className="slider-box"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {items.map((item, index) => (
            <div key={index}>
              <div
                className={`slider-item ${
                  index === currentIndex ? "active" : ""
                }`}
                style={getItemStyle(index)}
                data-tooltip-id={`slider-item-${index}`}
                onClick={handleGetStartedClick}
              >
                <img
                  src={item.image}
                  alt={item.name}
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "contain",
                  }}
                />
              </div>
              {index === currentIndex && (
                <ReactTooltip
                  id={`slider-item-${index}`}
                  place="top"
                  content={item?.description}
                  isOpen={index === currentIndex && showTooltip}
                  closeOnEsc={true}
                />
              )}
            </div>
          ))}
        </div>
        <div className="button-block">
          <div className="slider-btns">
            <button
              className="btn rounded-pill px-4 text-white left-btn"
              onClick={rotateLeft}
            >
              <i className="me-2 fa fa-chevron-left" />
            </button>
            {/* <span className="text-white">{items[currentIndex].name}</span> */}
            <img
              src={items[currentIndex].label}
              alt={items[currentIndex].name}
            />
            <button
              className="btn rounded-pill px-4 text-white right-btn"
              onClick={rotateRight}
            >
              <i className="ms-2 fa fa-chevron-right" />
            </button>
          </div>
          <div>
            {!userInfo?.is_verified && (
              <a
                className="btn hub-btn"
                disabled={isLoading}
                onClick={() => navigate("/onboarding/access")}
              >
                Get Started
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="hub-footer d-flex align-items-start justify-content-center">
        <Link to="/cookie-policy">Cookie Policy</Link>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms">Terms & Conditions</Link>
      </div>
    </div>
  );
};

export default Hub;
